import { ContextStore } from '../../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../../react-core/Async/Promise';
import { ProductPerformanceDetailModel } from '../../../Models/Models/PortfolioAnalysis/Performance/ProductPerformanceDetailModel';
import { IJsonDate } from '../../../System/IJsonDate';
import { PerformanceMethod } from '../../../Constants/Enums/Domain/PerformanceMethod';
import { AssetClassType } from '../../../Constants/Enums/Domain/Instrument/AssetClassType';
import { ViewType } from '../../../Mapping/PortfolioAnalysis/Investment/Enum/ViewType';

declare var IS_RUNNING_IN_APP_POOL;

export class ClientPerformanceDetailClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(headAccountHierarchyIds: Array<string>, hierarchyIds: Array<string>, fromDateTime: IJsonDate, toDateTime: IJsonDate, performanceMethod: PerformanceMethod, assetClassType: AssetClassType, fromInception: boolean, viewType: ViewType): Promise<Array<ProductPerformanceDetailModel>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/PortfolioAnalysis/Performance/ClientPerformanceDetail/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { headAccountHierarchyIds: headAccountHierarchyIds, hierarchyIds: hierarchyIds, fromDateTime: fromDateTime, toDateTime: toDateTime, performanceMethod: performanceMethod, assetClassType: assetClassType, fromInception: fromInception, viewType: viewType }

    return AjaxWrapper.get<Array<ProductPerformanceDetailModel>, any>(url, data);
  }
}

